import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-primary text-primary-foreground">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-up" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Prêt à profiter d'un service de nettoyage professionnel ?
          </h2>
          <p className="text-xl mb-8 opacity-90 animate-fade-up" style={{ animationDelay: '0.1s' }}>
            Contactez-nous dès aujourd'hui pour un devis gratuit et personnalisé. Notre équipe est à votre disposition pour répondre à tous vos besoins en nettoyage.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-up" style={{ animationDelay: '0.2s' }}>
            <Link to="/devis">
              <Button size="lg" variant="cta">
                Demander un devis gratuit
              </Button>
            </Link>
            <a href="tel:0769638777">
              <Button size="lg" variant="cta-outline">
                <Phone className="mr-2 h-5 w-5" />
                07 69 63 87 77
              </Button>
            </a>
          </div>

          <div className="mt-8 pt-8 border-t border-primary-foreground/20">
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
